import React from "react";
import { useInView } from "react-intersection-observer";
import "../Styles/Contacthero.css";
import teamImg from "../Assets/applynow.jpeg";
import parallaxImg from "../Assets/mdmessage.webp";

const Contacthero = () => {
  const [box1Ref, box1InView] = useInView({ triggerOnce: true, threshold: 0.5 });
  const [box2Ref, box2InView] = useInView({ triggerOnce: true, threshold: 0.5 });
  const [detailRef, detailInView] = useInView({ triggerOnce: true, threshold: 0.4 });
  const [mapRef, mapInView] = useInView({ triggerOnce: true, threshold: 0.4 });

  return (
    <div className="contacthero-container "id="careers">
      <div className="contacthero-header">
        <h1>Careers</h1>
      </div>

      <div className="contacthero-boxes">
        <div
          ref={box1Ref}
          className={`contacthero-box ${box1InView ? "animate-fadeUp" : ""}`}
        >
          <h2>Join Our Team</h2>
          <p>
            Be a part of a forward-thinking company that values innovation,
            dedication, and personal growth.
          </p>
          <div className="contacthero-layer">
            <span>Open positions available worldwide</span>
          </div>
        </div>

        <div
          ref={box2Ref}
          className={`contacthero-box ${box2InView ? "animate-fadeUp" : ""}`}
        >
          <h2>Why Work With Us</h2>
          <p>
            We offer a dynamic workplace, opportunities to grow, and an inclusive
            culture where everyone matters.
          </p>
          <div className="contacthero-layer">
            <span>Flexible hours and remote options</span>
          </div>
        </div>
      </div>

      <div
        ref={detailRef}
        className={`contacthero-detail ${detailInView ? "animate-fadeUp" : ""}`}
      >
        <div className="contacthero-text">
          <h2>Build Your Future With Us</h2>
          <p>
          Get in touch with DD Digital Construction for tailored digital marketing solutions that drive success and elevate your brand.
          </p>
        </div>
        <div className="contacthero-image">
          <img src={teamImg} alt="Our Team" />
        </div>
      </div>

      <div
        className="contacthero-parallax-section"
        style={{ backgroundImage: `url(${parallaxImg})` }}
      />

      <div
        ref={mapRef}
        className={`contacthero-map-wrapper ${mapInView ? "animate-fadeUp" : ""}`}
      >
        <div className="contacthero-address-box">
          <h3>Location</h3>
          <p>
           1st Branch Trichy,tamilnadu<br />           
           2nd Branch Karaikal,puducherry<br />
            Email: <a href="mailto:@dddigitalconstruction.com">@dddigitalconstruction.com</a><br />
            Mobile: +91  6380764850
          </p>
        </div>

        <div className="contacthero-map-box">
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d62680.84469183682!2d79.836178!3d10.921552000000002!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5511499b9b9c09%3A0x2d3f5081ddbcfb3a!2s36%2C%20Thirunallar%20Rd%2C%20Karaikal%2C%20Puducherry%20609602%2C%20India!5e0!3m2!1sen!2sus!4v1755928922580!5m2!1sen!2sus" width="100%" height="100%"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contacthero;
